/**
 * Asynchronously loads the component for TestDecisionScreen
 */

import { lazyLoad } from 'utils/loadable';

export const TestDecisionScreen = lazyLoad(
  () => import('./index'),
  module => module.TestDecisionScreen
);
